module.exports = __webpack_public_path__ + "static/media/Klain Qin.188ca33d.png";